module.exports = __webpack_public_path__ + "product.38d7ff12.png";